import React from 'react';
import {Card, FlexColumnSection, FlexRowSection, GreyText, SmallText, SpanBold} from '../styles/globalStyles';

/**
 * Generic label/value summary card (join waitlist summary, offer booking summary, expired booking details).
 * rows: [{label, value, separated?, bold?}]
 * separated: divider line above the row (e.g. payment section); bold: emphasized row (e.g. totals).
 */
const SummaryCard = ({title, rows, footer, style}) => (
    <Card flex={'unset'} style={{flexShrink: 0, ...(style || {})}}>
        <GreyText style={{padding: '16px 20px 13px', borderBottom: '1px solid #f0f0f0', fontWeight: 600, textTransform: 'uppercase', fontSize: 13}}>
            {title}
        </GreyText>
        <FlexColumnSection gap={'12px'} flex={'unset'} padding={'16px 20px'}>
            {rows.map(({label, value, separated, bold}) => (
                <FlexRowSection key={label} flex={'unset'} justify={'space-between'} gap={'12px'} style={separated ? {borderTop: '1px solid #f0f0f0', paddingTop: 12} : undefined}>
                    <SmallText weight={bold ? 600 : 400} style={{fontSize: bold ? 16 : 15}}>{label}</SmallText>
                    <SpanBold fontSize={bold ? '16px' : '15px'} style={{fontWeight: bold ? 600 : 500, textAlign: 'end'}}>{value}</SpanBold>
                </FlexRowSection>
            ))}
        </FlexColumnSection>
        {footer}
    </Card>
);

export default SummaryCard;
